import React, { useImperativeHandle, useState } from 'react';
import { Button, withTheme } from '@rneui/themed';
import { StyleSheet } from 'react-native';
import { useUserUUID } from '@annunciate/core';
import { FAIcon } from '../elements';
import { TagModal } from './TagModal';
export const UnthemedTagButton = React.forwardRef(({ item, iconStyle = {}, containerStyle = {}, buttonStyle = {}, size, isLeftAligned, isRightAligned, }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const uuid = useUserUUID();
    useImperativeHandle(ref, () => {
        return { toggle: () => setIsOpen((open) => !open) };
    }, [setIsOpen]);
    if (!uuid) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "clear", containerStyle: containerStyle, buttonStyle: buttonStyle, isLeftAligned: isLeftAligned, isRightAligned: isRightAligned, onPress: () => setIsOpen(true) },
            React.createElement(FAIcon, { name: "tag", size: size, style: StyleSheet.flatten([
                    iconStyle,
                    size ? { fontSize: size } : undefined,
                ]) })),
        isOpen && (React.createElement(TagModal, { item: item, closeModal: () => setIsOpen(false), isOpen: true }))));
});
export const TagButton = withTheme(UnthemedTagButton, 'TagButton');
//# sourceMappingURL=TagButton.js.map